import { alpha, styled as muiStyle } from '@mui/material/styles';
import { Tab, Tabs, TabsProps as MuiTabsProps, TabProps as MuiTabProps } from '@mui/material';
import { CustomTabProps } from '../types';

export const StyledTab = muiStyle(Tab, {
  shouldForwardProp: (prop) => !['badge'].includes(String(prop)), //(prop) => prop !== 'circled' && prop !== 'loading',
})<MuiTabProps & MuiTabsProps & CustomTabProps>(({ theme, variant, badge }) => ({
  maxWidth: `none`,
  minHeight: `44px`,
  padding: `0`,
  fontSize: `14px`,
  paddingLeft: `20px`,
  paddingRight: `20px`,
  fontWeight: `400`,
  border: `1px solid ${theme.palette.secondary[100]}`,
  textTransform: `none`,
  '& + &': {
    marginLeft: `-1px`,
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.secondary[800], 0.08),
  },
  '&.Mui-selected': {
    borderBottomColor: `transparent`,
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary[800], 0.08),
    },
  },
  ...(badge && {
    '&:after': {
      content: '""',
      display: `inline-block`,
      width: `5px`,
      height: `5px`,
      borderRadius: `5px`,
      backgroundColor: theme.palette.warning.main,
      marginLeft: `4px`,
      marginTop: `-10px`,
    },
  }),
  // ...(variant === 'fullWidth' && {
  //   width: `100%`,
  //   flex: 1,
  //   backgroundColor: alpha(theme.palette.secondary[800], 0.08),
  // }),
}));
export const StyledTabs = muiStyle(Tabs)<MuiTabsProps>(({ theme, orientation, variant }) => ({
  minHeight: `0`,
  // ...(variant === 'fullWidth' && {
  //   width: `100%`,
  //   '.MuiTabs-flexContainer': {
  //     width: `100%`,
  //   },
  //   '& .MuiTab-root': {
  //     flex: 1,
  //   },
  // }),
  '& .MuiTabs-indicator': {
    height: `3px`,
    bottom: `inherit`,
    top: `0`,
    backgroundColor: theme.palette.common.black,
  },

  ...(orientation === 'vertical' && {
    '& .MuiTabs-indicator': {
      width: `4px`,
      left: `0`,
      backgroundColor: theme.palette.primary.main,
    },
    '& .MuiTab-root': {
      border: `none`,
      minHeight: `40px`,
      justifyContent: `flex-start`,
      padding: `0 16px`,
      borderRadius: `3px`,
      fontWeight: `500`,
      '& + &': {
        marginTop: `8px`,
      },
      '&:hover': {
        backgroundColor: alpha(theme.palette.grayscaleSecondary[50], 0.5),
      },
      '&.Mui-selected': {
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.grayscaleSecondary[50], 0.5),
        '&:hover': {
          backgroundColor: alpha(theme.palette.grayscaleSecondary[50], 0.8),
        },
      },
    },
  }),
}));
